// extracted by mini-css-extract-plugin
export default {"dropdownStyle":"CYJ7XywNNRubSK3CYZCQ","competitionSelection":"OtPzg5_hcLqlTBe0IYgd"};